module.exports = __webpack_public_path__ + "static/img/bg-tr.18059ca4.webp";